<template>
  <div class="newspaper_layout">
    <div>
      <div class="shade" @click="$emit('close')"></div>
      <div class="body">
        <ul>
          <li
            v-for="(item, index) in pageList"
            v-text="item.edition + ':' + item.editionName"
            :key="index"
            @click="getMoreNewspapers(item)"
            :class="{ active: selectedBanMian == item }"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newspaperLayout",
  props: {
    pageList: {
      type: Array,
      required: true,
    },
    showLayout: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedBanMian: "",
    };
  },
  mounted() {
    console.log(this.pageList);
  },
  methods: {
    //点击版面获取相应的数字报
    getMoreNewspapers(item_) {
      this.selectedBanMian = item_;
      this.$emit("getNewspaperDetail", item_);
    },
  },
};
</script>
<style lang="less" scoped>
.newspaper_layout {
  & > div {
    .shade {
      position: absolute;
      left: 0;
      //top: 0.2rem;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
    }

    .body {
      width: 264px;
      height: 100%;
      overflow-y: auto;
      background: rgba(255, 255, 255, 1);
      padding: 19px 0 0 15px;
      box-sizing: border-box;
      z-index: 10 !important;
      box-shadow: 0rem 5px 10px 0rem rgba(0, 0, 0, 0.72);
      position: absolute;
      left: 0;
      bottom: 0;

      &::-webkit-scrollbar {
        display: none;
      }

      ul {
        padding: 0;
        margin: 0;

        li {
          height: 20px;
          font-size: 14px;
          font-weight: normal;
          color: rgba(42, 42, 42, 1);
          line-height: 20px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-bottom: 20px;

          &.active {
            color: rgba(224, 54, 38, 1);
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .newspaper_layout {
    & > div {
      .body {
        width: 100%;
        height: 50%;
      }
    }
  }
}
</style>